import versionData from "../version.json";

export const getSoftwareVersion = (): string => {
	return versionData.version.substring(0, versionData.version.indexOf("-"));
};

export const getSoftwareVersionCommitHash = (): string => {
	const split = versionData.version.split("-");

	return `${split[0]}-${split[2]}`;
};

export const getDyamachPrivacyPolicyUrl = (language: string): string => {
	if (["it", "it-IT"].includes(language)) {
		return "https://app.dyamach.com/privacy-policy/privacy-policy-it-2026-1.pdf";
	}

	return "https://app.dyamach.com/privacy-policy/privacy-policy-eng-2026-1.pdf";
};

export function getFloatMillimeters(valueMeters: number): number {
	return Number((valueMeters * 1e3).toFixed(2));
}

export function getIntegerMillimeters(valueMeters: number): number {
	return Math.round(valueMeters * 1e3);
}

export function getFloatMillimetersString(valueMeters: number): string {
	return `${getFloatMillimeters(valueMeters)} mm`;
}

export function getIntegerMillimetersString(valueMeters: number): string {
	return `${getIntegerMillimeters(valueMeters)} mm`;
}
